import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment } from "@fortawesome/free-solid-svg-icons";
import Card from "../layout/Card";
import Button from "../layout/Button";

// Número da própria instância Voki (ver companies/{id}/whatsapp/instance
// .phoneNumber) — canal de contato pra pedir a habilitação do módulo.
const VOKI_WHATSAPP_NUMBER = "551151996460";

function WhatsappModuleDisabled() {
  const onContact = () => {
    const text = encodeURIComponent(
      "Olá! Gostaria de habilitar o módulo de WhatsApp na minha conta Voki.",
    );
    window.open(
      `https://wa.me/${VOKI_WHATSAPP_NUMBER}?text=${text}`,
      "_blank",
      "noreferrer",
    );
  };

  return (
    <div className="flex items-center justify-center min-h-[70vh]">
      <Card className="max-w-md text-center py-10 px-8">
        <div className="w-14 h-14 rounded-full bg-purple/10 text-purple grid place-items-center mx-auto mb-5">
          <FontAwesomeIcon icon={faComment} className="text-2xl" />
        </div>
        <h2 className="font-bold text-primary text-base mb-2">
          Módulo de WhatsApp desabilitado
        </h2>
        <p className="text-xs text-gray-dark mb-6">
          Esse recurso ainda não está habilitado para a sua conta. Fale com a
          gente pelo WhatsApp para ativar.
        </p>
        <Button onClick={onContact}>Falar com o Voki no WhatsApp</Button>
      </Card>
    </div>
  );
}

export default WhatsappModuleDisabled;
